(() => {
  const bound = new WeakSet();
  const inquiryBySlug = Object.freeze({
    'medical-wig-sample': 'Medical wig sample quote',
    'stock-wig-trial': 'Stock wig trial order',
    'cap-construction': 'Cap construction sample',
    'color-ring': 'Color ring or hair swatch',
    'wholesale-private-label': 'Wholesale or private label',
    'help-choosing': 'Help choosing a medical wig',
    'order-support': 'Order or after-sales support'
  });
  const inquiryByKit = Object.freeze({
    'medical-wig': 'Medical wig sample quote',
    'cap-construction': 'Cap construction sample',
    'color-ring': 'Color ring or hair swatch',
    'stock-trial': 'Stock wig trial order'
  });

  function initialize(root = document) {
    const forms = root.matches?.('.shy-contact-form') ? [root] : root.querySelectorAll('.shy-contact-form');
    forms.forEach(form => {
      if (bound.has(form)) return;
      bound.add(form);
      const inquiry = form.querySelector('#ContactForm-inquiry-type');
      const buyer = form.querySelector('#ContactForm-buyer-type');
      const product = form.querySelector('[data-shy-contact-panel="product"]');
      const business = form.querySelector('[data-shy-contact-panel="business"]');
      const context = form.querySelector('[data-shy-contact-context]');
      const contextValue = form.querySelector('[data-shy-contact-context-value]');
      if (!inquiry || !buyer || !product || !business) return;
      const panels = [product, business];
      const values = new Set(Array.from(inquiry.options, option => option.value).filter(Boolean));
      const initialHash = window.location.hash;
      let manualPanels = new WeakSet();
      let prefilledValue = '';

      function openPanel(panel) {
        if (panel.open || manualPanels.has(panel)) return;
        panel.open = true;
      }

      function revealRelevant() {
        for (const panel of panels) {
          if (Array.from(panel.querySelectorAll('input, select, textarea')).some(field => field.value.trim())) {
            openPanel(panel);
          }
        }
        if (inquiry.value && inquiry.value !== 'Order or after-sales support') openPanel(product);
        if (inquiry.value === 'Wholesale or private label' || (buyer.value && buyer.value !== 'Individual wearer')) {
          openPanel(business);
        }
      }

      function showContext() {
        if (!context || !contextValue) return;
        context.hidden = !prefilledValue || inquiry.value !== prefilledValue;
        if (!context.hidden) contextValue.textContent = inquiry.selectedOptions[0]?.textContent || '';
      }

      function applyContext() {
        const params = new URLSearchParams(window.location.search);
        const raw = params.get('inquiry') || '';
        const requested = values.has(raw) ? raw : inquiryBySlug[raw] || inquiryByKit[params.get('kit') || ''];
        if (!inquiry.value && requested && values.has(requested)) {
          inquiry.value = requested;
          prefilledValue = requested;
          showContext();
        }
      }

      panels.forEach(panel => {
        panel.querySelector('summary')?.addEventListener('click', () => manualPanels.add(panel));
      });
      inquiry.addEventListener('change', () => {
        showContext();
        revealRelevant();
      });
      buyer.addEventListener('change', revealRelevant);
      form.addEventListener('invalid', event => {
        const panel = event.target.closest('[data-shy-contact-panel]');
        if (panel) panel.open = true;
      }, true);
      form.addEventListener('reset', () => {
        manualPanels = new WeakSet();
        prefilledValue = '';
        requestAnimationFrame(() => {
          panels.forEach(panel => { panel.open = false; });
          showContext();
        });
      });
      requestAnimationFrame(() => {
        applyContext();
        revealRelevant();
        if (initialHash === '#ContactForm' && prefilledValue) {
          inquiry.focus({ preventScroll: true });
          form.scrollIntoView({ block: 'start', behavior: 'instant' });
        }
      });
    });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => initialize(), { once: true });
  else initialize();
  document.addEventListener('shopify:section:load', event => initialize(event.target));
})();
